define("shared/components/shared/user/info", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
  
      <modal.card-header @title={{t "shared_words.users"}} />
  
      <modal.card-body class="u--p__t__0">
        <p>{{t "shared_phrases.users.info.description"}}</p>
        <br />
        <p class="u--text--md u--text--bold">
          {{t "shared_phrases.users.info.more.title"}}
        </p>
  
        <p>{{t "shared_phrases.users.info.more.num_included"}}</p>
        <p>{{t "shared_phrases.users.info.more.effective"}}</p>
        <p>{{html-safe (t "shared_phrases.users.info.more.note")}}</p>
      </modal.card-body>
  
      <modal.card-footer>
        <div class="o--btnBar u--float--right">
          <Shared::Ui::Button @onClick={{action @handleClose}} @text={{t "shared_words.close"}} @variant="outline" />
        </div>
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "UY6nXoYH",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"shared_words.users\"],null]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"shared_phrases.users.info.description\"],null]],[13],[1,\"\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.users.info.more.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[12],[1,[28,[35,1],[\"shared_phrases.users.info.more.num_included\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"shared_phrases.users.info.more.effective\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[[28,[37,1],[\"shared_phrases.users.info.more.note\"],null]],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,4],[[30,0],[30,1]],null],[28,[37,1],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\",\"action\"]]",
    "moduleName": "shared/components/shared/user/info.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});